import type { AuthSession } from "./types";

const SESSION_STORAGE_KEY = "vms.auth.session";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function isValidSession(value: unknown): value is AuthSession {
  if (!isRecord(value)) return false;
  return (
    typeof value.token === "string" &&
    typeof value.username === "string" &&
    typeof value.backendRole === "string" &&
    typeof value.companyCode === "string" &&
    (value.appRole === "gate" ||
      value.appRole === "admin-hr" ||
      value.appRole === "employee")
  );
}

export function readStoredSession(): AuthSession | null {
  const raw = localStorage.getItem(SESSION_STORAGE_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as unknown;
    return isValidSession(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function writeStoredSession(session: AuthSession): void {
  localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(session));
}

export function clearStoredSession(): void {
  localStorage.removeItem(SESSION_STORAGE_KEY);
}
